import { render, staticRenderFns } from "./post-pages.vue?vue&type=template&id=6e0cdf1c&scoped=true&"
import script from "./post-pages.ts?vue&type=script&lang=ts&"
export * from "./post-pages.ts?vue&type=script&lang=ts&"
import style0 from "./post-pages.scss?vue&type=style&index=0&id=6e0cdf1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0cdf1c",
  null
  
)

export default component.exports